var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolTreeDown = function SvgFiremapSymbolTreeDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M11.61 7.397a1.142 1.142 0 0 1 1.917.297.95.95 0 0 1 1.42.889 1.14 1.14 0 0 1 .696 1.46 1.14 1.14 0 0 1 .634 1.984 1.234 1.234 0 1 1-1.008 2.253 1.047 1.047 0 0 1-1.999-.09 1.14 1.14 0 0 1-1.304-1.487l-.61.603-1.901 1.884v1.05h7.587V17H6.958v-.76h2.064l-.13-.311h-.51l-.153-.739-1.098-1.096 1.631.128 1.816-1.213.555-.753a1.04 1.04 0 0 1-.364-.908 1.14 1.14 0 0 1-1.338-1.122c0-.488.31-.905.742-1.066a1.14 1.14 0 0 1 1.437-1.763",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolTreeDown;